import { Accordion } from "./accordion";

export class AccordionContainer {
  private el: HTMLElement;
  private accordions: Accordion[];
  private expandable: boolean;

  constructor(el: HTMLElement) {
    this.el = el;
    this.accordions = [];
    this.expandable = this.el.dataset.accordionExpandable === "true";
  }

  init() {
    this.el
      .querySelectorAll<HTMLElement>('[data-component="accordion"]')
      .forEach((accordionEl) => {
        const accordion = new Accordion(accordionEl, this).init();

        this.accordions.push(accordion);
      });
  }

  closeAllButCurrent(current: Accordion) {
    if (this.expandable) {
      return;
    }

    this.accordions.forEach((accordion) => {
      if (accordion !== current && accordion.isOpen()) {
        accordion.close();
      }
    });
  }

  isAnyAccordionAnimating() {
    return this.accordions.some((accordion) => accordion.isAnimating);
  }
}

type componentList = {
  [key: string]: { new (el: HTMLElement): { init(): void } };
}

const accordionComponents: componentList = {
  "accordion-container": AccordionContainer,
};

function initComponents(components: componentList, root = document) {
  Object.entries(components).forEach(([name, Component]) => {
    root
      .querySelectorAll<HTMLElement>(`[data-component="${name}"]`)
      .forEach((el) => new Component(el).init());
  });
}

if (document.readyState !== "loading") {
  initComponents(accordionComponents);
} else {
  document.addEventListener("DOMContentLoaded", () =>
    initComponents(accordionComponents),
  );
}
